import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { useAppSource, useSetAppSource } from 'stores/useAppSourceStore'
import { parseJsonString } from 'utils/parseJsonString'

export const useAppSourceTracker = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const appSource = useAppSource()
  const setAppSource = useSetAppSource()

  useEffect(() => {
    if (appSource) {
      return
    }

    const appSourceFromSearchParams = searchParams.get('appSource')

    if (typeof appSourceFromSearchParams !== 'string') {
      setAppSource(null)
      return
    }

    const parsedAppSource = parseJsonString(appSourceFromSearchParams)

    setAppSource(parsedAppSource)

    searchParams.delete('appSource')
    setSearchParams(searchParams)
  }, [appSource, searchParams, setSearchParams, setAppSource])
}
